'use es6';

export const EN = 'en';